import React from "react";

interface FeatureCardProps {
	icon: React.ReactNode;
	title: string;
	description: string;
}

export function FeatureCard({ icon, title, description }: FeatureCardProps) {
	return (
		<div className="glass-card rounded-xl p-5 transition-colors hover:border-white/15 hover:bg-white/[0.06]">
			<div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-[#db241e]/10 text-[#db241e]">
				{icon}
			</div>
			<h4 className="mb-1.5 text-sm font-semibold text-white">{title}</h4>
			<p className="text-sm leading-relaxed text-zinc-400">{description}</p>
		</div>
	);
}
